import { PlatformEnvironment } from '@mews/enums';

export const getBookingEngineUpsellingApplicationId = (environment: PlatformEnvironment) => {
    switch (environment) {
        case PlatformEnvironment.Demo:
            return 'd59dc6ca-473b-40c1-b19a-ae620087ac83';
        case PlatformEnvironment.Production:
            return '8328a606-9c70-4c9f-84aa-ae5200f9a54e';
        default:
            return 'ca9d5b3b-e2aa-4abb-a794-ae6200874d1a';
    }
};
